import { render, staticRenderFns } from "./AI.vue?vue&type=template&id=2f9907de&"
import script from "./AI.vue?vue&type=script&lang=js&"
export * from "./AI.vue?vue&type=script&lang=js&"
import style0 from "./AI.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/var/www/botter-dashbaord/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
installComponents(component, {VBtn,VContainer,VIcon,VLayout,VSpacer})
